(function () {
  var STORAGE_KEY = 'userAttribution';
  var PROXY_PREFIX = '/a/';
  var MAX_VALUE_LENGTH = 255;

  var PARAM_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'utm_id',
    'gclid',
    'gbraid',
    'wbraid',
    'fbclid',
    'ttclid',
    'msclkid',
    'irclickid',
    'epik',
  ];

  function readParams(search) {
    var params = new URLSearchParams(search);
    var found = {};

    PARAM_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value && value.length <= MAX_VALUE_LENGTH) {
        found[key] = value;
      }
    });

    return found;
  }

  function isEmpty(obj) {
    return Object.keys(obj).length === 0;
  }

  function read() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || null;
    } catch (e) {
      return null;
    }
  }

  function write(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (e) {
      /* storage unavailable */
    }
  }

  function capture(params) {
    if (isEmpty(params)) return;

    var now = Date.now();
    var stored = read() || { first: { date: now, utms: params } };

    stored.last = { date: now, utms: params };
    write(stored);
  }

  function pick(bag) {
    var found = {};
    if (!bag || typeof bag !== 'object') return found;

    PARAM_KEYS.forEach(function (key) {
      var value = bag[key];
      if (typeof value === 'string' && value && value.length <= MAX_VALUE_LENGTH) {
        found[key] = value;
      }
    });

    return found;
  }

  function stored() {
    var value = read();
    if (!value) return {};

    var last = pick(value.last && value.last.utms);
    if (!isEmpty(last)) return last;

    return pick(value.first && value.first.utms);
  }

  function isProxyLink(anchor) {
    if (!anchor || !anchor.getAttribute) return false;

    var href = anchor.getAttribute('href');
    if (!href || href.charAt(0) === '#') return false;

    try {
      var url = new URL(anchor.href, window.location.origin);
      return url.origin === window.location.origin && url.pathname.indexOf(PROXY_PREFIX) === 0;
    } catch (e) {
      return false;
    }
  }

  function decorate(anchor, params) {
    if (isEmpty(params) || !isProxyLink(anchor)) return;

    try {
      var url = new URL(anchor.href, window.location.origin);

      Object.keys(params).forEach(function (key) {
        url.searchParams.set(key, params[key]);
      });

      anchor.href = url.toString();
    } catch (e) {
      /* leave the href untouched */
    }
  }

  function decorateAll() {
    var params = stored();
    if (isEmpty(params)) return;

    document.querySelectorAll('a[href]').forEach(function (anchor) {
      decorate(anchor, params);
    });
  }

  capture(readParams(window.location.search));

  document.addEventListener(
    'click',
    function (event) {
      var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      decorate(anchor, stored());
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorateAll);
  } else {
    decorateAll();
  }
})();
